import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-splash-overlay',
  templateUrl: './splash-overlay.component.html',
  styleUrls: ['./splash-overlay.component.scss'],
  standalone:true
})
export class SplashOverlayComponent {
  @Input() isVisible: boolean = true;
  @Input() duration: number = 3000; // Default 3 seconds
  @Output() transitionEnd = new EventEmitter<void>();

  ngOnInit() {
    if (this.duration > 0) {
      setTimeout(() => {
        this.isVisible = false;
        this.transitionEnd.emit();
      }, this.duration);
    }
  }
} 